export default "__VITE_ASSET__Dh42wapl__"